<template>
  <div class="home-office">
    <el-row justify="center" class="mt-5">
      <el-col :span="22" align="center">
        <el-row justify="center">
          <el-col :span="14" align="center">
            <div class="persons-call mb-5">
              <div v-html="data.homeOfficeTexto"></div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row justify="center" class="remote mt-5 pt-5">
      <el-col :span="22" align="center">
        <el-row justify="center">
          <el-col :span="14" align="center">
            <div class="persons-call mb-5">
              <h3>Trabalho remoto</h3>
            </div>
          </el-col>
        </el-row>
        <el-row justify="center">
          <el-col :span="22" align="center">
            <div class="persons-call remote-text mb-5">
              <div v-html="data.remotoTexto"></div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row justify="center mt-5">
      <el-col :span="22" align="center">
        <el-row class="clients pb-5" justify="center" align="middle">
          <el-col align="center" :span="10">
            <div class="vacation-image">
              <figure>
                <img
                  class="video-img"
                  alt="Vue logo"
                  src="../../../assets/images/benefits/icone-QUANTO-MAIS-VIDEO-MELHOR.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="14">
            <el-row justify="center" class="clientes-titles mt-5">
              <el-col align="left">
                <div v-html="data.videoTexto"></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row justify="center mt-5">
      <el-col :span="22" align="center">
        <el-row class="clients pb-5" justify="center" align="middle">
          <el-col align="center" :span="10">
            <div class="vacation-image">
              <figure>
                <img
                  class="video-img"
                  alt="Vue logo"
                  src="../../../assets/images/benefits/vetores-09.png"
                />
              </figure>
            </div>
          </el-col>
          <el-col align="left" :span="14">
            <el-row justify="center" class="clientes-titles mt-5">
              <el-col align="left">
                <div v-html="data.clientesTexto"></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div class="close-btn-text mt-5 mb-5 last" @click="$emit('close-service')">Fechar</div>
  </div>
</template>

<script>
export default {
  name: 'HomeOffice',
  props: ['data'],
  setup () {
    return {}
  }
}
</script>
<style lang="scss" >
@import "~@/styles/variables.scss";
.home-office {
  ul {
    list-style: none; /* Remove default bullets */
  }

  ul li::before {
    content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
    color: $purple; /* Change the color */
    font-weight: bold; /* If you want it to be bold */
    display: inline-block; /* Needed to add space between the bullet and the text */
    width: 1em; /* Also needed for space (tweak if needed) */
  }

  li {
    font-size: 1.4rem;
    margin-bottom: 1reme;
  }

  h3 {
    text-transform: uppercase;
    color: $purple;
  }
  .remote {
    background-color: $white;
  }
  .remote-text{
    text-align: left;
  }
  .title {
    color: $purple;
    padding-right: 1rem;
    font-size: 1.8rem;
  }

  .last {
    margin-bottom: 20rem;
  }

  .blue {
    color: $light-blue;
  }

  .persons-call {
    max-width: 98rem;
    em {
      color: $light-blue;
      display: inline;
      font-size: 1.6rem;
      font-weight: normal;
    }
  }

  .video-img {
    margin-top: 5rem;
    height: 300px;
  }
}

.clients {
  background-color: $white;
}

.vacation-titles {

}
</style>
